import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '~/components/Loader';
import { useGetValuationDetailsQuery } from '~/redux/api/valuationApiSlice';
import Header from '~/modules/valuation/pages/ValuationResults/Header';
import ValuationResultsInfo from '~/modules/valuation/pages/ValuationResults/ValuationResultsInfo';
import RelatedListings from '~/modules/valuation/pages/ValuationResults/RelatedListings';
import ReturnOnInvestment from '~/modules/valuation/pages/ValuationResults/ReturnOnInvestment';
import CompareMarketValue from '~/modules/valuation/pages/ValuationResults/CompareMarketValue';
import MarketInsights from '~/modules/valuation/pages/ValuationResults/MarketInsights';
import { ValuationTypeEnum } from '~/constants/enums/valuationEnums';
import TopSellers from '~valuation/pages/ValuationResults/TopSellers';
import PropertyValuationEmptyState from '~/modules/valuation/pages/ValuationResults/PropertyValuationEmptyState';

const ValuationResults = () => {
  const { id } = useParams<{ id: string }>();
  const { isLoading, data, isError } = useGetValuationDetailsQuery(id, {
    skip: !id,
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  if (isLoading) return <Loader />;
  if (isError) return <div>Error loading valuation details.</div>;
  const valuationType = data?.valuation.type;
  const isEmptyState =
    !data?.valuation.currentValuation ||
    Boolean(!data?.valuation?.currentValuation?.valuationPrice);

  if (isEmptyState) return <PropertyValuationEmptyState />;

  return (
    <div className="layout-boundary py-2x md:py-4x !pb-20">
      <div className="layout-boundary__inner flex flex-col gap-4x px-2x md:px-0">
        <Header valuationType={valuationType} />
        <ValuationResultsInfo valuationData={data?.valuation} />
        {valuationType === ValuationTypeEnum.PORTFOLIO && (
          <>
            <div className="border border-gray rounded-[12px] px-2x md:px-3x py-3x flex flex-col gap-4x">
              <ReturnOnInvestment valuationData={data?.valuation} />
              <CompareMarketValue valuationData={data?.valuation} />
            </div>
            <MarketInsights valuationData={data?.valuation} />
          </>
        )}
        {valuationType === ValuationTypeEnum.ESTIMATION && (
          <>
            <RelatedListings
              location={data.valuation.location}
              propertyType={{
                id: data.valuation.propertyType.id,
                slug: data.valuation.propertyType.slug,
              }}
              section={{ id: 1, slug: 'for-sale' }}
            />
            <TopSellers
              propertyType={{
                id: data.valuation.propertyType?.id,
                slug: data.valuation.propertyType.slug,
              }}
              location={data.valuation.location}
              section={{
                id: 1,
                slug: 'for-sale',
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ValuationResults;
